import React from 'react';
import { Router } from '@abyss/web/ui/Router';

export const PlanDrawer = () => {
  return (
    <React.Fragment>
      <style>
        {`
        /* prototype structure code */
.protoWrap {
  max-width: 805px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-top: 60px;
  margin-bottom: 60px;
}

/* recommendation card */
.card {
  position: relative;
  display: flex;
}

.card-flair {
  position: absolute;
  height: 4rem;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #002677;
  border-top-right-radius: 36px;
  border-top-left-radius: 36px;
}

.card-inner {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, .15);
  margin-top: 1rem;
}

.card-hd {
  padding: 1rem;
}

.card-bd {
  flex: 1;
  padding: 1rem;
  background-color: #EEF8FB;
}

.card-ft {
  display: flex;
  align-items: center;
  padding: 1rem;
}

.card-title {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.card-title a {
  color: #002677;
  font-family: "UHC2020 Sans";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  text-decoration-line: underline;
  text-decoration-style: solid;
  line-height: 1.2;
}

.card-info {
  margin-bottom: 16px;
}

.card-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (min-width: 600px) {
  .card-grid {
    grid-template-columns: 160px 1fr;
  }
}

.card-data {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-data-hd {
  color: #4B4D4F;
  font-family: "UHC2020 Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.07;
}

.card-data-bd {
  color: #002677;
  font-family: "UHC Serif Headline";
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.06;
}

.orange-button {
  display: inline-flex;
  background: #d14600;
  border: 1px solid #d14600;
  height: 40px;
  padding: 0 20px;
  max-width: 168px;
  width: 100%;
  align-items: center;
  appearance: none;
  border-radius: 1.5rem;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  justify-content: center;
  line-height: 20px;
  position: relative;
  transition-duration: .25s;
  transition-property: background;
  transition-timing-function: cubic-bezier(.2,.8,.4,1);
  white-space: nowrap;
}

.orange-button:hover {
  background: #aa3600;
}

.arrow-button {
  display: inline-flex;
  align-items: center;
  color: #196ecf;
  text-decoration: none;
  font-weight: 700;
  font-size: 16px;
  appearance: none;
  border: 0;
  background: transparent;
}

.arrow-button:hover {
  text-decoration: underline;
}

/* CTA Card */
.cta-card {
  width: 100%;
  border-radius: 24px;
  border: 1px solid #CBCCCD;
  background: #F7FCFD;
  padding: 26px 20px;
}

.cta-card-hd {
  margin-bottom: 20px;
}

.cta-title {
  color: #002677;
  font-family: "UHC Serif Headline";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 16px;
}

.cta-card-ft {
  margin-top: 24px;
}

.alt-button {
  display: flex;
  height: 40px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 24px;
  border: 1px solid #002677;
  background: #fff;
  color: #002677;
  text-align: center;
  font-family: "UHC2020 Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}

.card-chronic .card-inner {
  border-top-left-radius: 0;
}

.card-chronic .card-flair {
  background-color: #F5B700;
}

.card-flair-chronic {
  position: relative;
  top: -19px;
  display: inline-flex;
  gap: 8px;
  align-items: center;
  background-color: #F5B700;
  padding: 7px 16px;
  font-size: 15px;
  font-weight: 700;
  border-radius: 12px 12px 0px 0px;
}

.card-flair-chronic-icon {
  height: 16px;
}

.card-chronic .card-bd {
  background: #FCF6F1;
}

html,
body {
  overflow: hidden;
}

.overlay {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.66);
  z-index: 99998;
}

.drawer {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  max-width: 572px;
  height: 100%;
  z-index: 99998;
  background: #fff;
}

.drawer-hd {
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

.drawer-title {
  color: #002677;
  font-family: "UHC Serif Headline";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
}

.drawer-options {
  height: 58px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.drawer-heading {
  display: flex;
  padding: 16px;
  gap: 16px;
  align-items: center;
}

@media (min-width: 500px) {
  .drawer-heading {
    padding: 24px 32px;
  }
}

.drawer-bd {
  flex: 1;
  overflow-y: auto;
  padding: 32px 16px;
}

@media (min-width: 500px) {
  .drawer-bd {
    padding: 32px;
  }
}

.drawer-bd > * + * {
  margin-top: 32px;
}

.drawer-bd > * + .card-chronic {
  margin-top: 52px;
}

.drawer-ft {
  width: 100%;
  height: 88px;
  bottom: 0;
  right: 0;
  border-top: 1px solid #CDCCCD;
  padding: 16px;
  background: #fff;
}

@media (min-width: 500px) {
  .drawer-ft {
    padding: 24px 32px;
  }
}

.drawer-buttons {
  display: flex;
  align-items: center;
  gap: 16px;
}

.drawer-buttons button {
  height: 48px;
}

.drawer-buttons > *,
.drawer-buttons > * > * {
  width: 100%;
}

.primary-button {
  display: inline-flex;
    background: #002677;
    border: 1px solid #002677;
    height: 40px;
    padding: 0 20px;
    width: 100%;
    align-items: center;
    appearance: none;
    border-radius: 1.5rem;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    justify-content: center;
    line-height: 20px;
    position: relative;
    transition-duration: .25s;
    transition-property: background;
    transition-timing-function: cubic-bezier(.2,.8,.4,1);
    white-space: nowrap;
}

.signin {
  background: #E5F8FB;
  padding: 24px;
  border-radius: 8px;
}

.signin-hd {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

.signin-hd-icon {
  height: 26px;
}

.signin-title {
  color: #002677;
  font-size: 20px;
  font-weight: 700;
}

.signin-head {
  margin-bottom: 8px;
  color: #323333;
  font-size: 17px;
  font-weight: 700;
}

.signin-list li + li {
  margin-top: 16px;
}

.signin-list a {
  color: #196ECF;
font-weight: 700;
  text-decoration-line: underline;
  text-decoration-style: solid;
}

.card-items {
  border-bottom: 1px solid #CBCCCD;
}

.card-list {
  padding: 16px;
}

.card-list li {
  display: flex;
  gap: 8px;
  align-items: center;
}

.card-list-icon {
  height: 24px;
}

.card-list li + li {
  margin-top: 16px;
}

.copy-bold {
  font-weight: 700;
}

`}
      </style>
      <Router.MetaTags title="Shopper Profile Drawer" />
      <div className="protoWrap">
        <div className="overlay"></div>
        <div className="drawer">
          <div className="drawer-hd">
            <div className="drawer-options">
              <div className="drawer-back">
                <button type="button" className="button-option">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_11124_6974)">
                      <path
                        d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
                        fill="#196ECF"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_11124_6974">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
              <div className="drawer-close">
                <button type="button" className="button-option">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_11124_5760)">
                      <path
                        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                        fill="#196ECF"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_11124_5760">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
            </div>
            <div className="drawer-heading">
              <div className="drawer-heading-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <g clip-path="url(#clip0_11142_13102)">
                    <path
                      d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
                      fill="#002677"
                    />
                    <path
                      d="M32.1501 14.4602L15.0901 31.5102L19.5801 36.0002L41.1201 14.4602H32.1501Z"
                      fill="white"
                    />
                    <path
                      d="M13.2981 20.7383L19.5841 27.0243L15.0941 31.5143L8.80811 25.2283L13.2981 20.7383Z"
                      fill="#00BED5"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_11142_13102">
                      <rect width="48" height="48" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="drawer-title">Added to your saved plans</div>
            </div>
          </div>
          <div className="drawer-bd">
            <div className="card">
              <div className="card-flair"></div>
              <div className="card-inner">
                <div className="card-hd">
                  <div className="card-title">
                    <a href="#">
                      AARP Medicare Advantage Essentials from UHC GA-7 (PPO)
                    </a>
                    <span>
                      <svg
                        width="21"
                        height="19"
                        viewBox="0 0 21 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path
                          d="M9.75797 18.2973C10.0097 18.3806 10.2571 18.4223 10.5002 18.4223C10.7432 18.4223 10.9906 18.3806 11.2423 18.2973C11.4941 18.2139 11.7154 18.0806 11.9064 17.8973L13.6772 16.3473C15.5522 14.7306 17.2276 13.1223 18.7033 11.5223C20.179 9.92227 20.9168 8.16393 20.9168 6.24727C20.9168 4.6806 20.37 3.37227 19.2762 2.32227C18.1825 1.27227 16.8196 0.747268 15.1877 0.747268C14.2675 0.747268 13.3995 0.934768 12.5835 1.30977C11.7675 1.68477 11.0731 2.19727 10.5002 2.84727C9.92725 2.19727 9.2328 1.68477 8.41683 1.30977C7.60086 0.934768 6.7328 0.747268 5.81266 0.747268C4.18072 0.747268 2.81787 1.27227 1.72412 2.32227C0.630371 3.37227 0.0834961 4.6806 0.0834961 6.24727C0.0834961 8.16393 0.825683 9.9181 2.31006 11.5098C3.79443 13.1014 5.45676 14.7056 7.29704 16.3223L9.09391 17.8973C9.28488 18.0806 9.50624 18.2139 9.75797 18.2973Z"
                          fill="#002677"
                        ></path>
                      </svg>
                    </span>
                  </div>
                </div>
                <div className="card-bd">
                  <div className="card-info card-grid">
                    <div className="card-data">
                      <div className="card-data-hd">Monthly premium</div>
                      <div className="card-data-bd">$0</div>
                    </div>
                    <div className="card-data">
                      <div className="card-data-hd">Out-of-pocket maximum</div>
                      <div className="card-data-bd">$6,700</div>
                    </div>
                  </div>
                  <div className="card-grid">
                    <button type="button" className="orange-button">
                      Enroll in plan
                    </button>
                    <button type="button" className="arrow-button">
                      <span>Compare plan</span>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path
                          d="M8.58997 16.59L13.17 12L8.58997 7.41L9.99997 6L16 12L9.99997 18L8.58997 16.59Z"
                          fill="currentColor"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="card-ft">
                  <button type="button" className="arrow-button">
                    <span>View plan details</span>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <path
                        d="M8.58997 16.59L13.17 12L8.58997 7.41L9.99997 6L16 12L9.99997 18L8.58997 16.59Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div className="card card-chronic">
              <div className="card-flair">
                <div className="card-flair-chronic">
                  <div>Chronic condition required</div>
                  <div className="card-flair-chronic-icon">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.99992 11.333C8.18881 11.333 8.34714 11.2691 8.47492 11.1413C8.6027 11.0136 8.66659 10.8552 8.66659 10.6663V7.99967C8.66659 7.81079 8.6027 7.65245 8.47492 7.52467C8.34714 7.3969 8.18881 7.33301 7.99992 7.33301C7.81103 7.33301 7.6527 7.3969 7.52492 7.52467C7.39714 7.65245 7.33325 7.81079 7.33325 7.99967V10.6663C7.33325 10.8552 7.39714 11.0136 7.52492 11.1413C7.6527 11.2691 7.81103 11.333 7.99992 11.333ZM7.99992 5.99967C8.18881 5.99967 8.34714 5.93579 8.47492 5.80801C8.6027 5.68023 8.66659 5.5219 8.66659 5.33301C8.66659 5.14412 8.6027 4.98579 8.47492 4.85801C8.34714 4.73023 8.18881 4.66634 7.99992 4.66634C7.81103 4.66634 7.6527 4.73023 7.52492 4.85801C7.39714 4.98579 7.33325 5.14412 7.33325 5.33301C7.33325 5.5219 7.39714 5.68023 7.52492 5.80801C7.6527 5.93579 7.81103 5.99967 7.99992 5.99967ZM7.99992 14.6663C7.0777 14.6663 6.21103 14.4913 5.39992 14.1413C4.58881 13.7913 3.88325 13.3163 3.28325 12.7163C2.68325 12.1163 2.20825 11.4108 1.85825 10.5997C1.50825 9.78856 1.33325 8.9219 1.33325 7.99967C1.33325 7.07745 1.50825 6.21079 1.85825 5.39967C2.20825 4.58856 2.68325 3.88301 3.28325 3.28301C3.88325 2.68301 4.58881 2.20801 5.39992 1.85801C6.21103 1.50801 7.0777 1.33301 7.99992 1.33301C8.92214 1.33301 9.78881 1.50801 10.5999 1.85801C11.411 2.20801 12.1166 2.68301 12.7166 3.28301C13.3166 3.88301 13.7916 4.58856 14.1416 5.39967C14.4916 6.21079 14.6666 7.07745 14.6666 7.99967C14.6666 8.9219 14.4916 9.78856 14.1416 10.5997C13.7916 11.4108 13.3166 12.1163 12.7166 12.7163C12.1166 13.3163 11.411 13.7913 10.5999 14.1413C9.78881 14.4913 8.92214 14.6663 7.99992 14.6663ZM7.99992 13.333C9.48881 13.333 10.7499 12.8163 11.7833 11.783C12.8166 10.7497 13.3333 9.48856 13.3333 7.99967C13.3333 6.51079 12.8166 5.24967 11.7833 4.21634C10.7499 3.18301 9.48881 2.66634 7.99992 2.66634C6.51103 2.66634 5.24992 3.18301 4.21659 4.21634C3.18325 5.24967 2.66659 6.51079 2.66659 7.99967C2.66659 9.48856 3.18325 10.7497 4.21659 11.783C5.24992 12.8163 6.51103 13.333 7.99992 13.333Z"
                        fill="#002677"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="card-inner">
                <div className="card-hd">
                  <div className="card-title">
                    <a href="#">UHC Complete Care MO-1 (PPO C-SNP)</a>
                    <span>
                      <svg
                        width="21"
                        height="19"
                        viewBox="0 0 21 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path
                          d="M9.75797 18.2973C10.0097 18.3806 10.2571 18.4223 10.5002 18.4223C10.7432 18.4223 10.9906 18.3806 11.2423 18.2973C11.4941 18.2139 11.7154 18.0806 11.9064 17.8973L13.6772 16.3473C15.5522 14.7306 17.2276 13.1223 18.7033 11.5223C20.179 9.92227 20.9168 8.16393 20.9168 6.24727C20.9168 4.6806 20.37 3.37227 19.2762 2.32227C18.1825 1.27227 16.8196 0.747268 15.1877 0.747268C14.2675 0.747268 13.3995 0.934768 12.5835 1.30977C11.7675 1.68477 11.0731 2.19727 10.5002 2.84727C9.92725 2.19727 9.2328 1.68477 8.41683 1.30977C7.60086 0.934768 6.7328 0.747268 5.81266 0.747268C4.18072 0.747268 2.81787 1.27227 1.72412 2.32227C0.630371 3.37227 0.0834961 4.6806 0.0834961 6.24727C0.0834961 8.16393 0.825683 9.9181 2.31006 11.5098C3.79443 13.1014 5.45676 14.7056 7.29704 16.3223L9.09391 17.8973C9.28488 18.0806 9.50624 18.2139 9.75797 18.2973Z"
                          fill="#002677"
                        ></path>
                      </svg>
                    </span>
                  </div>
                </div>
                <div className="card-bd">
                  <div className="card-info card-grid">
                    <div className="card-data">
                      <div className="card-data-hd">Monthly premium</div>
                      <div className="card-data-bd">$0</div>
                    </div>
                    <div className="card-data">
                      <div className="card-data-hd">Out-of-pocket maximum</div>
                      <div className="card-data-bd">$4,400</div>
                    </div>
                  </div>
                  <div className="card-grid">
                    <button type="button" className="arrow-button">
                      <span>Compare plan</span>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path
                          d="M8.58997 16.59L13.17 12L8.58997 7.41L9.99997 6L16 12L9.99997 18L8.58997 16.59Z"
                          fill="currentColor"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="card-items">
                  <ul className="card-list">
                    <li>
                      <span className="card-list-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_11142_25681)">
                            <path
                              d="M12 3C9.90496 3 8.20996 4.745 8.20996 6.79V17.21C8.20996 19.255 9.90496 21 12 21C14.095 21 15.79 19.255 15.79 17.21V6.79C15.79 4.745 14.095 3 12 3ZM9.20996 6.79C9.20996 5.275 10.49 4 12 4C13.51 4 14.79 5.275 14.79 6.79V10.77L9.20996 13.195V6.79Z"
                              fill="#002677"
                            />
                            <path
                              d="M12 3C9.90496 3 8.20996 4.745 8.20996 6.79V13.625L15.79 10.33V6.785C15.79 4.745 14.095 3 12 3Z"
                              fill="#00BED5"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_11142_25681">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      <span className="card-list-copy">
                        Prescription drug coverage
                      </span>
                    </li>

                    <li>
                      <span className="card-list-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_11142_25687)">
                            <path
                              d="M15.225 8.045C14.9999 7.87507 14.8172 7.65523 14.6914 7.40276C14.5656 7.15029 14.5001 6.87208 14.5 6.59V6.5H15V3H9V6.5H9.5V6.59C9.5 7.16 9.23 7.7 8.775 8.045C8.3798 8.3414 8.0589 8.7256 7.83763 9.16727C7.61636 9.60894 7.50078 10.096 7.5 10.59V19.5C7.5 20.05 7.95 20.5 8.5 20.5H15.5C16.05 20.5 16.5 20.05 16.5 19.5V10.59C16.5 9.59 16.03 8.645 15.225 8.045ZM10 4H14V5.5H10V4ZM15.5 18H8.5V13.5L15.5 10.5V18Z"
                              fill="#002677"
                            />
                            <path
                              d="M9 3H15V6.5H9V3ZM16.33 9.575L7.5 13.5V18H16.5V10.59C16.5 10.24 16.44 9.9 16.33 9.575Z"
                              fill="#00BED5"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_11142_25687">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      <span className="card-list-copy">
                        <span className="copy-bold">$49</span> credit every
                        month for OTC and food
                      </span>
                    </li>

                    <li>
                      <span className="card-list-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_11142_25694)">
                            <path
                              d="M5.82203 15.8037H6.75053V9.80371H3.15503L5.82203 15.8037Z"
                              fill="#00BED5"
                            />
                            <path
                              d="M13.49 8.55306H20.5C20.7652 8.55306 21.0195 8.65842 21.2071 8.84596C21.3946 9.03349 21.5 9.28785 21.5 9.55306C21.5 9.81828 21.3946 10.0726 21.2071 10.2602C21.0195 10.4477 20.7652 10.5531 20.5 10.5531H16.5C16.7652 10.5531 17.0195 10.6584 17.2071 10.846C17.3946 11.0335 17.5 11.2878 17.5 11.5531C17.5 11.8183 17.3946 12.0726 17.2071 12.2602C17.0195 12.4477 16.7652 12.5531 16.5 12.5531H16C16.2652 12.5531 16.5195 12.6584 16.7071 12.846C16.8946 13.0335 17 13.2878 17 13.5531C17 13.8183 16.8946 14.0726 16.7071 14.2602C16.5195 14.4477 16.2652 14.5531 16 14.5531H15C15.2652 14.5531 15.5195 14.6584 15.7071 14.846C15.8946 15.0335 16 15.2878 16 15.5531C16 15.8183 15.8946 16.0726 15.7071 16.2602C15.5195 16.4477 15.2652 16.5531 15 16.5531H9.99998C9.0663 16.5538 8.16933 16.1895 7.50048 15.5381V16.5531H5.33498L2.00098 9.05306H7.50098V9.32406C7.78836 9.04053 8.12132 8.80729 8.48598 8.63406L8.48248 8.62906L15.1875 5.58706C15.4288 5.48339 15.7012 5.47881 15.9459 5.57434C16.1906 5.66986 16.3878 5.8578 16.4951 6.09756C16.6023 6.33733 16.6109 6.60965 16.519 6.85571C16.4271 7.10176 16.2421 7.30178 16.004 7.41256L13.491 8.55306H13.49ZM5.82198 15.8031H6.75048V9.80306H3.15498L5.82198 15.8031Z"
                              fill="#002677"
                            />
                            <path
                              d="M19.9715 12.5537C19.9715 12.5537 18.7715 14.4032 18.7715 15.3537C18.7715 15.5113 18.8025 15.6673 18.8628 15.8129C18.9231 15.9585 19.0115 16.0908 19.123 16.2022C19.2344 16.3137 19.3667 16.4021 19.5123 16.4624C19.6579 16.5227 19.8139 16.5537 19.9715 16.5537C20.1291 16.5537 20.2851 16.5227 20.4307 16.4624C20.5763 16.4021 20.7086 16.3137 20.82 16.2022C20.9314 16.0908 21.0198 15.9585 21.0801 15.8129C21.1404 15.6673 21.1715 15.5113 21.1715 15.3537C21.1715 14.4032 19.9715 12.5537 19.9715 12.5537Z"
                              fill="#00BED5"
                            />
                            <path
                              d="M5.334 16.5537H7.5V9.05371H2L5.334 16.5537Z"
                              fill="#00BED5"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_11142_25694">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      <span className="card-list-copy">
                        <span className="copy-bold">$25</span> or less for
                        covered insulin
                      </span>
                    </li>

                    <li>
                      <span className="card-list-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_11142_25703)">
                            <path
                              d="M17.97 8.25009C17.78 6.73509 16.55 5.47009 15.045 5.24509C14.86 5.21509 14.68 5.20509 14.5 5.20509C13.94 5.20509 13.4 5.33509 12.905 5.59009C12.6254 5.73505 12.315 5.81071 12 5.81071C11.6851 5.81071 11.3747 5.73505 11.095 5.59009C10.6019 5.33573 10.0549 5.20368 9.50004 5.20509C9.32004 5.20509 9.13504 5.22009 8.95504 5.24509C7.45004 5.47509 6.22004 6.73509 6.03004 8.25009C5.93004 9.06509 6.10004 9.86009 6.53004 10.5451C7.17504 11.5801 7.50504 12.6451 7.50504 13.7101V15.7051C7.50504 16.7201 7.83504 17.6751 8.45504 18.4701C8.66504 18.7401 8.92504 18.7951 9.10504 18.7951C9.54504 18.7951 10 18.4651 10 17.9101V17.2851C10 16.2601 10.69 15.3951 11.645 15.2301C11.765 15.2101 11.88 15.2001 12 15.2001C13.105 15.2001 14 16.0951 14 17.2001V17.9101C14 18.4601 14.455 18.7951 14.895 18.7951C15.075 18.7951 15.335 18.7401 15.545 18.4701C16.163 17.6812 16.4976 16.7073 16.495 15.7051V13.7101C16.495 12.6451 16.82 11.5801 17.47 10.5451C17.9004 9.8623 18.0774 9.05004 17.97 8.25009Z"
                              fill="white"
                            />
                            <path
                              d="M18.4701 8.19008C18.2551 6.44508 16.8601 5.01508 15.1251 4.75008C14.9101 4.72008 14.7051 4.70508 14.5001 4.70508C13.8401 4.70508 13.2201 4.86508 12.6751 5.14508C12.4666 5.2535 12.235 5.31011 12.0001 5.31011C11.7651 5.31011 11.5335 5.2535 11.3251 5.14508C10.7605 4.85505 10.1348 4.70419 9.50005 4.70508C9.29505 4.70508 9.09005 4.72008 8.88005 4.75008C7.14005 5.01508 5.75005 6.44508 5.53505 8.19008C5.41505 9.15508 5.64005 10.0651 6.10505 10.8101C6.65505 11.6901 7.00005 12.6751 7.00005 13.7101V15.7051C7.00005 16.8651 7.39505 17.9301 8.05505 18.7801C8.33505 19.1401 8.72005 19.3001 9.10005 19.3001C9.80505 19.3001 10.4951 18.7551 10.4951 17.9151V17.2901C10.4951 16.5451 10.9951 15.8551 11.7251 15.7301C11.9413 15.6901 12.1637 15.6983 12.3765 15.754C12.5892 15.8097 12.7871 15.9116 12.9561 16.0524C13.125 16.1932 13.2609 16.3694 13.354 16.5687C13.4472 16.7679 13.4953 16.9852 13.4951 17.2051V17.9151C13.4951 18.7551 14.1851 19.3001 14.8901 19.3001C15.2701 19.3001 15.6551 19.1401 15.9351 18.7801C16.6198 17.9014 16.9911 16.8191 16.9901 15.7051V13.7101C16.9901 12.6751 17.3401 11.6901 17.8851 10.8101C18.381 10.0323 18.588 9.10498 18.4701 8.19008ZM17.0501 10.2801C16.3551 11.3951 16.0001 12.5501 16.0001 13.7101V15.7051C16.0001 16.6051 15.7101 17.4551 15.1551 18.1651C15.0851 18.2551 15.0001 18.3001 14.8951 18.3001C14.7901 18.3001 14.5001 18.2301 14.5001 17.9151V17.2051C14.5001 15.8251 13.3801 14.7051 12.0001 14.7051C11.8551 14.7051 11.7051 14.7201 11.5601 14.7451C10.3651 14.9501 9.50005 16.0201 9.50005 17.2901V17.9151C9.50005 18.2251 9.20505 18.3001 9.10505 18.3001C9.00005 18.3001 8.92005 18.2601 8.84505 18.1651C8.29405 17.4638 7.99627 16.5969 8.00005 15.7051V13.7101C8.00005 12.5501 7.64505 11.3951 6.95005 10.2801C6.58399 9.69452 6.43369 8.99958 6.52505 8.31508C6.68505 7.02008 7.74005 5.93508 9.03005 5.74008C9.18505 5.71508 9.34505 5.70508 9.50005 5.70508C9.98005 5.70508 10.4401 5.81508 10.8701 6.03508C11.2212 6.21538 11.6103 6.30943 12.0051 6.30943C12.3998 6.30943 12.7889 6.21538 13.1401 6.03508C13.5651 5.81508 14.0251 5.70508 14.5051 5.70508C14.6601 5.70508 14.8201 5.71508 14.9751 5.74008C16.2651 5.93508 17.3201 7.01508 17.4801 8.31508C17.5651 9.01508 17.4151 9.69508 17.0501 10.2801Z"
                              fill="#002677"
                            />
                            <path
                              d="M9.47012 7.44031C9.60012 7.44031 9.72012 7.46531 9.84012 7.50531L10.4051 6.94031C10.1251 6.79031 9.81012 6.69531 9.47012 6.69531C8.38012 6.69531 7.49512 7.58031 7.49512 8.67031H8.24512C8.24512 7.99031 8.79512 7.44031 9.47012 7.44031Z"
                              fill="#00BED5"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_11142_25703">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      <span className="card-list-copy">
                        <span className="copy-bold">$250</span> eyewear
                        allowance and eye exam
                      </span>
                    </li>

                    <li>
                      <span className="card-list-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_11142_25718)">
                            <path
                              d="M21.5 14.64V12.425C21.5 11.86 21.18 11.34 20.675 11.085L19.085 10.29L17.445 6.595C17.3661 6.41814 17.2378 6.26788 17.0754 6.16231C16.9131 6.05674 16.7237 6.00037 16.53 6H4.5C3.95 6 3.5 6.45 3.5 7V14.635C3.2 14.81 3 15.13 3 15.5H4.5C4.5 16.605 5.395 17.5 6.5 17.5C7.605 17.5 8.5 16.605 8.5 15.5H15.5C15.5 16.605 16.395 17.5 17.5 17.5C18.605 17.5 19.5 16.605 19.5 15.5H22C22 15.13 21.8 14.81 21.5 14.64ZM6.5 16.5C5.95 16.5 5.5 16.05 5.5 15.5C5.5 14.95 5.95 14.5 6.5 14.5C7.05 14.5 7.5 14.95 7.5 15.5C7.5 16.05 7.05 16.5 6.5 16.5ZM17.5 16.5C16.95 16.5 16.5 16.05 16.5 15.5C16.5 14.95 16.95 14.5 17.5 14.5C18.05 14.5 18.5 14.95 18.5 15.5C18.5 16.05 18.05 16.5 17.5 16.5Z"
                              fill="#002677"
                            />
                            <path
                              d="M4.5 7.00488H8V9.99988H4.5V7.00488ZM16.525 7.00488H13.5V9.99988H17.86L16.525 7.00488ZM9 7.00488H12.5V9.99988H9V7.00488Z"
                              fill="#00BED5"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_11142_25718">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      <span className="card-list-copy">
                        24 rides for doctor and pharmacy visits
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="card-ft">
                  <button type="button" className="arrow-button">
                    <span>View plan details</span>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <path
                        d="M8.58997 16.59L13.17 12L8.58997 7.41L9.99997 6L16 12L9.99997 18L8.58997 16.59Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div className="signin">
              <div className="signin-hd">
                <div className="signin-hd-icon">
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.0833 12.5666V8.66663C14.0833 8.35968 13.9795 8.10239 13.7718 7.89475C13.5642 7.68711 13.3069 7.58329 13 7.58329C12.693 7.58329 12.4357 7.68711 12.2281 7.89475C12.0204 8.10239 11.9166 8.35968 11.9166 8.66663V12.9729C11.9166 13.1173 11.9437 13.2573 11.9979 13.3927C12.052 13.5281 12.1333 13.65 12.2416 13.7583L15.8166 17.3333C16.0152 17.5319 16.268 17.6312 16.575 17.6312C16.8819 17.6312 17.1347 17.5319 17.3333 17.3333C17.5319 17.1347 17.6312 16.8819 17.6312 16.575C17.6312 16.268 17.5319 16.0152 17.3333 15.8166L14.0833 12.5666ZM13 23.8333C11.5013 23.8333 10.093 23.5489 8.77496 22.9802C7.4569 22.4114 6.31038 21.6395 5.33538 20.6645C4.36038 19.6895 3.5885 18.543 3.01975 17.225C2.451 15.9069 2.16663 14.4986 2.16663 13C2.16663 11.5013 2.451 10.093 3.01975 8.77496C3.5885 7.4569 4.36038 6.31038 5.33538 5.33538C6.31038 4.36038 7.4569 3.5885 8.77496 3.01975C10.093 2.451 11.5013 2.16663 13 2.16663C14.4986 2.16663 15.9069 2.451 17.225 3.01975C18.543 3.5885 19.6895 4.36038 20.6645 5.33538C21.6395 6.31038 22.4114 7.4569 22.9802 8.77496C23.5489 10.093 23.8333 11.5013 23.8333 13C23.8333 14.4986 23.5489 15.9069 22.9802 17.225C22.4114 18.543 21.6395 19.6895 20.6645 20.6645C19.6895 21.6395 18.543 22.4114 17.225 22.9802C15.9069 23.5489 14.4986 23.8333 13 23.8333ZM13 21.6666C15.4013 21.6666 17.4461 20.8225 19.1343 19.1343C20.8225 17.4461 21.6666 15.4013 21.6666 13C21.6666 10.5986 20.8225 8.55378 19.1343 6.86558C17.4461 5.17739 15.4013 4.33329 13 4.33329C10.5986 4.33329 8.55378 5.17739 6.86558 6.86558C5.17739 8.55378 4.33329 10.5986 4.33329 13C4.33329 15.4013 5.17739 17.4461 6.86558 19.1343C8.55378 20.8225 10.5986 21.6666 13 21.6666Z"
                      fill="#002677"
                    />
                  </svg>
                </div>
                <div className="signin-title">Save time. Every time</div>
              </div>
              <div className="signin-bd">
                <ul className="signin-list">
                  <li>
                    <div className="signin-head">UnitedHealthcare members</div>
                    <div className="signin-copy">
                      {' '}
                      <a href="#">Create an account</a> or{' '}
                      <a href="#">sign in</a> to import your drugs and providers
                      from your claims history.
                    </div>
                  </li>

                  <li>
                    <div className="signin-head">Not yet a member?</div>
                    <div className="signin-copy">
                      {' '}
                      <a href="#">Create an account</a> or{' '}
                      <a href="#">sign in</a>, then start or updated your drug
                      list.
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="drawer-ft">
            <div className="drawer-buttons">
              <div>
                <button type="button" className="alt-button">
                  Keep shopping
                </button>
              </div>
              <div>
                <button type="button" className="primary-button">
                  See your plans
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
